<section class="stats">
  <div class="stat-group">
    <article>{{ advert().streetNameAndHouseNumber }}</article>
    <article>{{ advert().direction }}</article>
    <article>{{ advert().postalCodeAndCity }}</article>
  </div>
  <div class="teaser-stats-group">
    <article class="item">
      @if (advert().showNumberOfRooms) {
        <article>
          {{ advert().numberOfRooms }}
          {{ advert().numberOfRoomsLabel | translate }}
        </article>
      }
      @if (advert().showMarketingNumberOfRooms) {
        <article>
          {{ advert().marketingNumberOfRooms }}
          {{ advert().numberOfRoomsLabel | translate }}
        </article>
      }

      @if (advert().showNumberOfBedrooms) {
        <article>
          {{ advert().numberOfBedrooms }}
          {{ advert().numberOfBedroomsLabel | translate }}
        </article>
      }
      @if (advert().showMarketingNumberOfBedrooms) {
        <article>
          {{ advert().marketingNumberOfBedrooms }}
          {{ advert().numberOfBedroomsLabel | translate }}
        </article>
      }

      @if (advert().showUnitSize) {
        <article>{{ advert().size | numeral }} {{ advert().areaSizeUnit }}</article>
      }
      @if (advert().showMarketingUnitSize) {
        <article>
          {{ advert().marketingSize | numeral }} {{ advert().areaSizeUnit }}
        </article>
      }
    </article>

    <article class="item">
      @if (advert().cost) {
        <span
          >{{ 'KEY_FACTS.cost' | translate }} {{ advert().cost | numeral }} {{ advert().localization.currency }}</span
          >
        }
        @if (!advert().cost) {
          <span>{{ 'KEY_FACTS.cost' | translate }} -</span>
        }
      </article>
      <article>&nbsp;</article>
    </div>
    <div class="teaser-contact">
      <article>
        {{ advert().hasNoContactAssigned ? ('SHARED_COMPONENT.NO_CONTACT' | translate) : advert().contactDisplay }}
      </article>
      @if (advert().hasSubstituteContact) {
        <article>
          , {{ advert().substituteContact.firstName }} {{ advert().substituteContact.lastName }}
        </article>
      }
      @if (!advert().hasSubstituteContact) {
        <article>&nbsp;</article>
      }
    </div>
  </section>
